import { ImageWithFallback } from '@/components/shared/NextImageFallback';
import { Button } from '@/components/ui/button';
import { useSession } from '@/contexts/LitSessionProvider';
import { useRecentToken } from '@/hooks/saved/useRecentToken';
import { useTouchHandlerName } from '@/hooks/utilities/use-mobile';
import getNetworkLogo from '@/lib/misc/getNetworkLogo';
import { CATEGORIES, EVENTS, LogToMixpanel } from '@/lib/misc/mixpanel';
import { V2Networks } from '@shared/utils/config/networkAddresses';
import { useRouter } from 'next/router';
import { IoTriangle } from 'react-icons/io5';
import { TbTriangleInverted, TbTriangleInvertedFilled } from 'react-icons/tb';
export default function RecentResults({
  subMemeData,
  onTokenClick,
  timeFrame,
  network
}) {
  if (!subMemeData || subMemeData?.length < 1) return;
  const {
    PKP
  } = useSession();
  const {
    handleClearRecentTokens
  } = useRecentToken();
  const tokens = subMemeData?.filter(token => token !== null)?.sort((a, b) => parseFloat(b[`change${timeFrame}`]) - parseFloat(a[`change${timeFrame}`]))?.map(token => {
    return {
      ...token,
      name: token.token.symbol,
      image: token.token.imageSmallUrl,
      percent: (parseFloat(token[`change${timeFrame}`]) * 100)?.toFixed(2)
    };
  });
  const router = useRouter();
  const touchHandlerName = useTouchHandlerName();
  return <div className='w-full mb-4 ta-l px-4' data-sentry-component="RecentResults" data-sentry-source-file="RecentResults.tsx">
      <div className='flex justify-between items-center w-full'>
        <p className='text-[16px] text-genius-gradient flex items-center'>
          Recent Searches

        </p>
        <Button variant='purple' className='h-[32px] text-[14px] w-[74px]' {...{
        [touchHandlerName]: () => {
          handleClearRecentTokens();
        }
      }} data-sentry-element="Button" data-sentry-source-file="RecentResults.tsx">
          Clear
        </Button>
      </div>
      <div className='flex items-center pt-4 space-x-2  overflow-x-scroll no-scrollbar'>
        {tokens?.map((token, index) => {
        const tokenItem = token.token;
        return <div {...{
          [touchHandlerName]: () => {
            if (onTokenClick) {
              LogToMixpanel({
                pkp: PKP,
                eventName: EVENTS.search.clickTopToken,
                category: CATEGORIES.search,
                metaData: {
                  tokenAddress: tokenItem?.address,
                  networkId: tokenItem?.networkId
                }
              });
              onTokenClick(tokenItem);
            } else {
              router.push(`/asset?address=${tokenItem?.address}&networkId=${tokenItem?.networkId}`);
            }
          }
        }} key={index} className='rounded-full h-[36px] flex items-center min-w-[140px] bg-genius-blue p-[20px] pl-[10px] border-genius-blue border-[1px]'>
              <div className='w-fit flex items-center pr-2 relative'>
                <ImageWithFallback src={token?.token?.info?.imageThumbUrl} alt={`${token.name} logo`} className='rounded-full w-[28px] h-[28px] mr-2' height={24} width={24} />
                <ImageWithFallback src={getNetworkLogo(token.token.networkId)} alt='network logo' className='w-[16px] h-[16px] top-3 left-4 absolute  shrink-0' height={10} width={10} />{' '}
                <div className='flex items-center'>
                  <p className='text-[14px] ml-2 text-genius-cream'>{token.name}</p>
                </div>
                <div className={`flex items-center  ml-2 ${token.percent > 0 ? 'text-green-400' : 'text-red-400'}`}>
                  {/* {token.percent > 0 ? (
                    <IoTriangle className='w-[10px] h-[10px] mr-1' />
                   ) : (
                    <TbTriangleInvertedFilled className='w-[10px] h-[10px] mr-1' />
                   )}
                   <p className='text-[12px]'>{token.percent}%</p> */}
                </div>
              </div>
            </div>;
      })}
      </div>
    </div>;
}